module.exports = __webpack_public_path__ + "img/emoji-smile.ebd9e298.png";